var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLtv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    fillOpacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0049 23.5V21.5H20.0049V35.5H36.0049V33.5H28.0049C27.4526 33.5 27.0049 33.0523 27.0049 32.5V24.5C27.0049 23.9477 27.4526 23.5 28.0049 23.5H36.0049ZM19.0049 19.5H37.0049C37.5572 19.5 38.0049 19.9477 38.0049 20.5V36.5C38.0049 37.0523 37.5572 37.5 37.0049 37.5H19.0049C18.4526 37.5 18.0049 37.0523 18.0049 36.5V20.5C18.0049 19.9477 18.4526 19.5 19.0049 19.5ZM29.0049 25.5V31.5H36.0049V25.5H29.0049ZM31.0049 27.5H34.0049V29.5H31.0049V27.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.06
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtv);
export default __webpack_public_path__ + "static/media/ltv.2bdc32132223a4c1e1a64b78d25a1cf8.svg";
export { ForwardRef as ReactComponent };